import React from 'react';

const SimpleBurgerIcon = () => {
  return (
    <svg className="simple-burger" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 406.09 404.6">
      <path d="M464.89,409.51A33.41,33.41,0,0,0,432.52,376v0H125.87a33.5,33.5,0,0,0,0,67c.32,0,.63,0,.95,0H430.59l1,0c.32,0,.63,0,.95,0h0A33.41,33.41,0,0,0,464.89,409.51Z" transform="translate(-87.52 -77.62)" style={{ fill: "#ffffff" }} />

      <path d="M421.41,284.81H136c-24,0-43.49,16.53-43.49,36.92S112,358.65,136,358.65h285.4c24,0,43.48-16.53,43.48-36.92S445.42,284.81,421.41,284.81Z" transform="translate(-87.52 -77.62)" style={{ fill: "rgba(255,255,255,.4)" }} />

      <path d="M438.39,216.42H119c-14.64,0-26.51,10.6-26.51,23.68s11.87,23.68,26.51,23.68H438.39c14.64,0,26.5-10.6,26.5-23.68S453,216.42,438.39,216.42Z" transform="translate(-87.52 -77.62)" style={{ fill: "rgba(255,255,255,.7)" }} />

      <path d="M463.93,168.64c-6.89-50.88-87.26-91-185.42-91a338.58,338.58,0,0,0-64,6,58.24,58.24,0,0,1,5.34,24.29c0,37-35.15,67-78.51,67a87.46,87.46,0,0,1-46.77-13.17,53.44,53.44,0,0,0-1.8,10.8A26.43,26.43,0,0,0,119,202.24H438.39a26.53,26.53,0,0,0,25.54-33.6Z" transform="translate(-87.52 -77.62)" style={{ fill: "#ffffff" }} />
    </svg>
  )
}

export default SimpleBurgerIcon;